<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      
            <v-card class="box">
                  <v-col cols="12" sm="12" md="12">
                       <center class="heading">
                    <strong> <h3>{{ formTitle }}</h3> </strong>
                </center>
                        <v-row class="my-2">
                            <v-col cols="12" sm="4" md="4">
                            <v-autocomplete
                                dense
                                v-model="editedItem.course"
                                :items="course_list"
                                item-text="course"
                                item-value="id"
                                label="Select Subject"
                                persistent-hint
                                :disabled="editedIndex != -1"
                                :filled="editedIndex==-1?false:true"
                                return-object
                                single-line
                            ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                            <v-autocomplete dense :items="templates" v-model="template" item-text="name" return-object label="Select Template"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                            <v-autocomplete dense :items="exams" v-model="exam" return-object item-text="name" label="Select Exam"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <div class="my-2">
                            <center>
                                <v-btn @click="applyTemplate" class="button">Apply Template</v-btn>
                            </center>
                        </div>
                  </v-col>
            </v-card>
        
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            overlay: false,
            snackbar_msg: "",
            snackbar: false,
            color: "",
            iseditable: false,
            load: false,
            dialog: false,
            course_list: null,
            selected_course: "",
            templates: null,
            template: null,
            exams: null,
            exam: null,
            //crs_list: null,
            errorMsg: {
                course: false,
            },

            editedIndex: -1,
            editedItem: {
                id: 0,
                course: "",
            },
            defaultItem: {
                id: 0,
                course: "",
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Apply Template" : "";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            axios
                .post("/QPTemplate/courseTemplate")
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.course_list = res.data.course_list;
                        this.templates = res.data.templates;
                        this.exams = res.data.exams;
                        this.load = true;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            initializeErrorMsgFalse() {
                this.errorMsg.course = false;
            },
            applyTemplate() {
                // console.log(this.editedItem.course)
                // console.log(this.template)
                if (this.editedItem.course == "" || this.template == null || this.exam == null) {
                    this.showSnackbar("#b71c1c", "Please select course, template and exam");
                    return;
                }
                const formData = {
                    course: this.editedItem.course,
                    template: this.template,
                    exam: this.exam,
                };
                axios
                    .post("/QPTemplate/applyTemplateToCourse", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4CAF50", res.data.snackbar);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .box {
    background-color: #a9d9ec49;
    margin: 8px !important;
    padding: 10px;
    /* border: 3px solid hsla(190, 99%, 30%, 1) !important;
    border-radius: 40px; */
}
</style>
